import React from "react";
import Contact from "../../components/contact/Contact";
import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import Subsribe from "../../components/newsletter/Subsribe";
import PageHeader from "../../components/team/PageHeader";
import Value from "../../components/values/Value";

export default function OurValues({ information }) {
  return (
    <Layout>
      <Navbar darkBg information={information} />
      <PageHeader HeaderTitle="Our Values" Parent="Our Values" />
      <Value hasBg />
      <Contact information={information} />
      {/* <Subsribe /> */}
      <Footer space information={information} />
    </Layout>
  );
}
